var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAlertsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98024 12H12.0202C13.0469 12 13.6869 10.8866 13.1736 9.99996L8.15358 1.32662C7.64024 0.439954 6.36024 0.439954 5.84691 1.32662L0.82691 9.99996C0.313577 10.8866 0.953577 12 1.98024 12ZM7.00024 7.33329C6.63358 7.33329 6.33358 7.03329 6.33358 6.66662V5.33329C6.33358 4.96662 6.63358 4.66662 7.00024 4.66662C7.36691 4.66662 7.66691 4.96662 7.66691 5.33329V6.66662C7.66691 7.03329 7.36691 7.33329 7.00024 7.33329ZM7.66691 9.99996H6.33358V8.66662H7.66691V9.99996Z",
    fill: "#F57762CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAlertsIcon);
export default __webpack_public_path__ + "static/media/critical_alerts_icon.5be2b61c07d224519a7f253a08976152.svg";
export { ForwardRef as ReactComponent };